import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public menus = [
        { label: '대시보드', link: '/dashboard', icon: '▦' },
        { label: '문헌 작업', link: '/documents', icon: '▤' },
        { label: '개체 검수', link: '/entity-review', icon: '◎' },
        { label: '관계 검수', link: '/relation-review', icon: '↔' },
        { label: '그래프 탐색', link: '/graph', icon: '⌁' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public isActive(link: string) {
        return location.pathname === link || location.pathname.indexOf(link + '/') === 0;
    }

    public activeClass(link: string) {
        const base = 'group flex items-center gap-2.5 rounded-md px-2.5 py-2 text-[13px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500';
        return this.isActive(link)
            ? base + ' bg-indigo-50 text-indigo-700'
            : base + ' text-zinc-600 hover:bg-zinc-100 hover:text-zinc-950';
    }

    public async closeMobile() {
        await this.service.status.toggle('navbar', true);
    }
}

export default ComponentNavSidebarComponent;